export const info = {
  'seo.title': 'Analysis Review — Nutritional Consultation | Sofia and Elena',
  'seo.description': 'Detailed review of your analyses, individual nutrition selection and lifestyle recommendations from expert nutritionists Sofia and Elena.',
  'seo.keywords': 'analysis review, nutritionist consultation, individual nutrition, health recommendations',

  'hero.title': 'Analysis Review',
  'hero.description': 'A detailed review of your analyses with individual nutrition recommendations and a personalized action plan.',

  'section1.title': 'What\'s included in the service:',
  'section1.paragraph1': 'We conduct a thorough review of all your laboratory analyses and health markers, identifying deficiencies, imbalances and areas that need attention.',
  'section1.paragraph2': 'Based on the results, we create a personalized nutrition plan tailored specifically to your body\'s needs and health goals.',

  'section2.title': 'How it works:',
  'section2.item1': 'You send your analyses',
  'section2.item2': 'We conduct a detailed review',
  'section2.item3': 'We meet for a consultation',
  'section2.item4': 'You receive a personalized meal plan',

  'section3.title': 'Why choose us:',
  'section3.paragraph1': 'With two experts reviewing your analyses simultaneously, you get a comprehensive perspective that covers both nutritional science and cosmetology aspects of your health.',
  'section3.paragraph2': 'Our approach is not about temporary fixes — we help you understand your body so you can make informed decisions about your health for life.',

  'cta.title': 'Ready to start your journey to health?',
  'cta.description': 'Book a consultation and get a personalized nutrition plan based on your analyses.',
  'cta.button': 'Choose Package',
  'cta.buttonAria': 'Choose a package',
};